const ExploreTools = (() => {
    const tabletViewMax = 1024;
    const smallScreensViewMax = 1440;

    function hotspotSelect() {
        // - change active hotspot after click
        $('.explore-block .hotspot-svg a').click(function(event) {
            event.preventDefault();

            var  selectedHotspot = $(this).parent();

            if(selectedHotspot.hasClass('selected')) {
                selectedHotspot.removeClass('selected')
            } else {
                $('.explore-block').find('.hotspot-svg.selected').removeClass('selected');
                selectedHotspot.addClass('selected');
            }

            const activeTooltipId = $(this).parent().attr('hotspot-id');
            const activeTooltip = $('.explore__info .hotspot-item.tooltip-active');
            const clickedHotspotTooltip = $('.explore__info .hotspot-item[hotspot-id="' + activeTooltipId + '"]');

            // Find active hotspot tooltip
            if(clickedHotspotTooltip.hasClass('tooltip-active')) {
                clickedHotspotTooltip.removeClass('tooltip-active');
            } else {
                activeTooltip.removeClass('tooltip-active');
                clickedHotspotTooltip.addClass('tooltip-active');
            }

            tooltipShow();

            // scroll tooltip into viewport on small devices
            if ($(window).width() < smallScreensViewMax) {
                if($('.explore__info .hotspot-item').hasClass('tooltip-active')) {
                    $('html,body').animate({scrollTop: clickedHotspotTooltip.offset().top - clickedHotspotTooltip.height()}, 700);
                } else {
                    $('html,body').animate({scrollTop: $('.explore-block').offset().top - 40}, 700);
                }

                
            }
        });
    }

    function tooltipShow() {
        if ($(window).width() > tabletViewMax) {
            // Active slide Tooltip title cloned inside selected hotpot
            var tooltipTitle = $('.explore__info .hotspot-item.tooltip-active h3').html();
            $('.explore-block .hotspot-svg.selected h3').html(tooltipTitle);

            // Active slide Tooltip text cloned inside selected hotpot
            var tooltipText = $('.explore__info .hotspot-item.tooltip-active p').html();
            $('.explore-block .hotspot-svg.selected p').html(tooltipText);
        }

        // Safari and Firefox fix for unsupported CSS dynamic foreignObject attributes
        if ($(window).width() > tabletViewMax && $(window).width() < smallScreensViewMax) {
            $('.explore-block .hotspot-svg.selected foreignObject').attr('width', '200').attr('height', '700').attr('x', '-80').attr('y', '-705');
        }
    }

    return {
        init() {
            hotspotSelect();
        },
    };
})();

export default (() => {
    $(document).ready(ExploreTools.init);
})();